module.exports = __webpack_public_path__ + "cf33f346efe8396c0ecdacee38923f3b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-banner-king.svg
// module id = 468
// module chunks = 0